module.exports = __webpack_public_path__ + "static/pic03.de584414.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pic03.jpg
// module id = 353
// module chunks = 114276838955818